
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.7 3.5H9.3c-2.1 0-3.7 1.7-3.7 3.7v38.7h16.1V37c0-.6.4-1.1 1-1.1h4.6c.5 0 1 .5 1 1.1v8.9h16.2V7.2c-.1-2-1.8-3.7-3.8-3.7zM17.3 40.4c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6V9.6c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.8zm10.9 18c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6V9.6c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.8zm10.7 27c0 .3-.3.6-.6.6H33c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6H33c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6H33c-.3 0-.6-.3-.6-.6v-3.9c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.9zm0-9c0 .3-.3.6-.6.6H33c-.3 0-.6-.3-.6-.6V9.6c0-.3.3-.6.6-.6h5.3c.3 0 .6.3.6.6v3.8z"}})])
          )
        }
      }
    